import { render, staticRenderFns } from "./Son_Radio.vue?vue&type=template&id=b9b36c7e&scoped=true&"
import script from "./Son_Radio.vue?vue&type=script&lang=js&"
export * from "./Son_Radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b36c7e",
  null
  
)

export default component.exports